import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createRow(
  lecture,
  lab,
  tutorial,
  mentoring,
  advisory,
  curriculum,
  id
) {
  return (
    <TableRow
      key={id}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell align="left">{lecture}</TableCell>
      <TableCell align="left">{lab}</TableCell>
      <TableCell align="left">{tutorial}</TableCell>
      <TableCell align="left">{mentoring}</TableCell>
      <TableCell align="left">{advisory}</TableCell>
      <TableCell align="left">{curriculum}</TableCell>
    </TableRow>
  );
}

//const rows = [
//  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
//  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
//  createData("Eclair", 262, 16.0, 24, 6.0),
//  createData("Cupcake", 305, 3.7, 67, 4.3),
//  createData("Gingerbread", 356, 16.0, 49, 3.9),
//];

export default function BasicTable({ data, head }) {
  console.log(data);
  return (
    <TableContainer
      sx={{
        width: "100%",
        border: "0.5px solid",
        borderColor: "teritiary.main",
      }}
    >
      <Table sx={{ minWidth: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ backgroundColor: "teritiary.lighter1" }}>
            {head.map((colHead) => {
              return (
                <TableCell
                  sx={{ fontSize: "0.8rem", textTransform: "capitalize" }}
                >
                  {colHead.label}
                  {colHead?.unit ? ` (${colHead.unit})` : ""}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.curriculums?.map((curriculum, index) => {
            return createRow(
              index === 0 ? data.lecture : "",
              index === 0 ? data.lab : "",
              index === 0 ? data.tutorial : "",
              index === 0 ? data.mentoring : "",
              index === 0 ? data.advisory : "",
              curriculum.name,
              curriculum.id
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
